import { all, takeEvery } from 'redux-saga/effects'

import { CommentsActions } from '../actions'
import { create } from './create'
import { deleteComment } from './delete'
import { update } from './update'

export function* commentsSaga() {
  yield all([
    takeEvery(CommentsActions.update, update),
    takeEvery(CommentsActions.delete, deleteComment),
    takeEvery(CommentsActions.create, create),
  ])
}
